module.exports = __webpack_public_path__ + "assets/img/dashenlin.e5dfdcfd.png";